import { Grid, Stack } from "@mui/material";
import email from "assets/footer/email.png";
import whatsApp from "assets/footer/whatsapp.png";
import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useAppApi } from "store/api-context";
import { useAppAuth } from "store/auth-context";
import { capitalizeFirstLetter } from "utils/common/common.utils";
import { ROUTES } from "utils/constants/route.constants";
import useWindowDimension from "utils/hooks/use-dimension.hook";
import { FooterContainer } from "./footer.style";

const Logo = ({ mainClient, className }) => (
  <div className={`logo ${className}`}>
    <h3 style={{ margin: 0 }}>{mainClient?.name?.split(" ")[0]}</h3>
    <h3 style={{ margin: 0 }}>{mainClient?.name?.split(" ")[1]}</h3>
  </div>
);
export default function Footer() {
  const { mainClient } = useAppAuth();
  const {
    state: { overviews },
  } = useAppApi();

  const { pathname } = useLocation();
  const { isMobile, isTablet, isDesktop } = useWindowDimension();

  const clientName = `${capitalizeFirstLetter(
    mainClient?.name?.split(" ")[0]
  )} ${capitalizeFirstLetter(mainClient?.name?.split(" ")[1])}`;

  const isHomePage = useMemo(() => pathname === ROUTES.HOME, [pathname]);

  if (pathname === ROUTES.DELETE_USER || pathname === ROUTES.PRIVACY_POLICY) {
    return null;
  }

  return (
    <FooterContainer data-testid="footer_container" isHomePage={isHomePage}>
      <Grid
        container
        sx={{
          padding: {
            xs: "0 1rem",
            md: "5rem",
            lg: "0 20rem",
          },
        }}
      >
        <Grid
          item
          xs={12}
          data-testid="footer_content_container"
          className="footer_content_container"
          sx={{
            marginBottom: {
              xs: "0rem",
              md: "0rem",
            },
          }}
        >
          <h3 data-testid="footer_title" className="footer_title">
            Find Latest and Timeless Classics
          </h3>
          <p data-testid="footer_description" className="footer_description">
            Creating jewelries that are unique yet classic with precision and
            quality that gives “timeless joy’ to each individual who wears it is
            the heart and soul of us.
          </p>
        </Grid>
        <Grid
          className="copywright"
          item
          xs={12}
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{
            marginTop: "4rem",
          }}
        >
          <Grid
            item
            xs={12}
            md={4}
            sx={{
              display: { xs: "none", md: "flex" },
              justifyContent: { xs: "center", md: "flex-start" },
            }}
          >
            {(!isTablet && !isMobile) || isDesktop ? (
              <div>
                <p data-testid="copywright_text" className="copywright_text">
                  Copyright © 1988 {clientName}
                </p>
              </div>
            ) : null}
          </Grid>
          <Grid item xs={12} md={4}>
            <Logo className="desktop_logo" mainClient={mainClient} />
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
            display="flex"
            alignItems="flex-end"
            justifyContent={{
              xs: "flex-start",
              md: "center",
            }}
            sx={{
              display: { xs: "flex", md: "flex" },
              justifyContent: { xs: "flex-start", md: "flex-end" },
            }}
          >
            <Stack
              sx={{
                display: {
                  xs: "none",
                  md: "flex",
                },
                flexDirection: {
                  xs: "column",
                  md: "row",
                },
                gap: {
                  xs: "1rem",
                },
                textAlign: {
                  sx: "left",
                },
                justifyContent: {
                  md: "center",
                  xs: "",
                },
                alignItems: {
                  xs: "flex-start",
                  md: "center",
                },
              }}
            >
              <div style={{ width: "100%" }}>
                <p className="get_in_touch">Get In Touch</p>
              </div>
              <Stack
                sx={{
                  flexDirection: "row",
                  justifyContent: {
                    sx: "flex-start",
                  },
                  display: {
                    xs: "none",
                    md: "flex",
                  },
                }}
              >
                <a
                  href={`https://api.whatsapp.com/send?phone=${overviews?.[0]?.support?.whatsApp}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="whatsapp_icon_desktop cursor-pointer"
                    //   style={{ marginLeft: "1.9rem" }}
                    src={whatsApp}
                    alt="whatsapp"
                    height={"45px"}
                    width={"45px"}
                  />
                </a>
                <a href="mailto:test@example.com">
                  <img
                    className="email_icon_desktop cursor-pointer"
                    src={email}
                    alt="mail"
                    height={"45px"}
                    width={"45px"}
                    style={{
                      marginLeft: "1.9rem",
                    }}
                  />
                </a>
              </Stack>
            </Stack>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            justifyContent: "space-between",
            marginTop: "1rem",
            display: {
              md: "none",
              xs: "flex",
            },
            alignItems: "center",
          }}
        >
          <div>
            <p className="copywright_text">Copyright © 1988 {clientName}</p>
          </div>

          <Stack
            sx={{
              flexDirection: "row",
              justifyContent: {
                sx: "flex-start",
              },
            }}
          >
            <a
              href={`https://api.whatsapp.com/send?phone=${overviews?.[0]?.support?.whatsApp}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className="whatsapp_icon cursor-pointer"
                //   style={{ marginLeft: "1.9rem" }}
                src={whatsApp}
                alt="whatsapp"
                height={"45px"}
                width={"45px"}
              />
            </a>
            <a href="mailto:example@example.com">
              <img
                className="email_icon cursor-pointer"
                src={email}
                alt="mail"
                height={"45px"}
                width={"45px"}
                style={{
                  marginLeft: "0.6rem",
                }}
              />
            </a>
          </Stack>
        </Grid>
      </Grid>
    </FooterContainer>
  );
}
